export const KEYCODE = {
  ESCAPE: 27,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  TAB: 9
}

export const MEDIA_QUERIES = {
  MOBILE: 360,
  TABLET: 768,
  TABLET_LANDSCAPE: 1024,
  DESKTOP: 1280,
  MODULE_MAX: 1240,
  WIDE: 1600
}

export function stringToBoolean(str) {
  return str === 'true'
}

export const focusableElements = [
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])',
  'a[href]',
  'area[href]',
  'button:not([disabled]):not([aria-hidden])',
  'embed',
  'iframe',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'object',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])'
]

export function setViewportHeight() {
  function handleResize() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
  }

  handleResize()
  window.addEventListener('resize', handleResize)
}

export const reactComponent = (Component, nodeList) => {
  const React = require('react')
  const { render } = require('react-dom')

  nodeList.forEach((node) => render(<Component {...node.dataset} />, node))
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
